/*
  Charm row – snippets/charm-row.liquid
  - Gold | Silver toggle at the top of the row. It starts on the plating of the
    necklace's selected variant (and follows the necklace's variant changes);
    without a plating there, Gold, else the first plating in the row.
    The toggle sets every charm's image and the variant the plus adds. A charm
    that does not come in the chosen plating is dimmed with "Only in silver"
    and the plus adds the plating it has – never another colour silently.
  - Plating of a variant: the option whose values are all gold/silver words
    (GOLD/SILVER below, every shop language), else the handle token
    -gold- / -silver- (Sanya Initial Charm is two products, one per plating,
    shown as one tile – see data-tile in the snippet).
  - Before the necklace is in the cart, the plus only picks the charm; the
    product form's button becomes "Add all N to cart" and adds the necklace
    and the picked charms in one /cart/add.js call (items: [...]).
  - Once the necklace is in the cart, the plus adds the charm straight away
    (/cart/add.js) and a second click removes its lines (/cart/update.js).
  - Letters (an option whose values are single letters): the picker lets the
    customer pick several letters and the same letter several times; one cart
    line per letter, quantity = count. Only the stock of a variant limits it.
  - Any other option with more than one value (Wren "Color") opens the picker.
  - Every charm line gets the hidden property _look = the necklace's handle.
  - Charm discount (TILLÄGG 3, counted by the CHARM-DISCOUNT function – the
    theme never calculates a price): the steps from the block settings, a hint
    from the number of charms of this collection in the cart + picked now, and
    "Discount applied in cart" under the ordinary "Your look" total.
*/
(function () {
  if (window.customElements.get('charm-row')) return;

  function money(cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function route(path) {
    return (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + path;
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) throw data;
        return data;
      });
    });
  }

  // Gold / Silver as option values in the shop's 15 languages (the translations
  // of Plating checked 2026-10-14): en, sv/da, no, de, nl, fr, es/it, pt, fi,
  // fil, ja, zh-CN, ar.
  var GOLD = /^(gold|guld|gull|goud|or|oro|ouro|kulta|ginto|ゴールド|金色?|ذهبي?)$/i;
  var SILVER = /^(silver|sølv|silber|zilver|argent|argento|plata|prata|hopea|pilak|シルバー|银色?|銀色?|فضة|فضي)$/i;
  var DOT = { gold: '#d4a62a', silver: '#c9c9c9' };
  var ORDER = ['gold', 'silver'];

  function platingOf(name) {
    var n = String(name || '').trim();
    if (GOLD.test(n)) return 'gold';
    if (SILVER.test(n)) return 'silver';
    return null;
  }

  function platingFromHandle(handle) {
    var h = '-' + handle + '-';
    if (h.indexOf('-gold-') >= 0) return 'gold';
    if (h.indexOf('-silver-') >= 0) return 'silver';
    return null;
  }

  // Index of the option whose values are all plating words, or -1.
  function platingIndex(options) {
    for (var i = 0; i < options.length; i++) {
      if (options[i].values.length && options[i].values.every(function (v) { return platingOf(v.name); })) return i;
    }
    return -1;
  }

  function shortName(title) {
    return String(title).split(' - ')[0].split(' – ')[0].trim();
  }

  function isLetters(option) {
    return option.values.length >= 10 && option.values.every(function (v) { return /^\S{1,2}$/.test(v.name); });
  }

  class CharmRow extends HTMLElement {
    connectedCallback() {
      var json = this.querySelector('[data-charm-row-json]');
      if (!json) return;
      this.data = JSON.parse(json.textContent);
      this.t = this.data.texts;
      this.look = this.dataset.look;
      this.lookName = this.dataset.lookName;
      this.form = document.getElementById(this.dataset.formId);
      this.platingNames = {};
      var look = this.data.look;
      this.lookPlatingIdx = platingIndex(look.options.map(function (name, i) {
        var values = [];
        look.variants.forEach(function (v) { if (values.indexOf(v.options[i]) < 0) values.push(v.options[i]); });
        return { name: name, values: values.map(function (n) { return { name: n }; }) };
      }));
      this.buildTiles();

      this.picked = {};   // tileKey -> [{ rest: [values], qty }] (not yet in the cart)
      this.inCart = {};   // tileKey -> [{ key, variantId, qty, price }]
      this.lookInCart = false;
      this.collectionInCart = 0;  // pieces of this row's charms in the cart (any line)
      this.lookVariant = this.findLookVariant(look.selected);
      this.plating = this.defaultPlating();

      this.buildToggle();
      this.buttons.forEach(function (btn) {
        btn.addEventListener('click', this.onCharm.bind(this, btn));
      }.bind(this));

      this.picker = this.querySelector('[data-charm-picker]');
      this.querySelector('[data-picker-cancel]').addEventListener('click', this.closePicker.bind(this));
      this.querySelector('[data-picker-add]').addEventListener('click', this.confirmPicker.bind(this));

      document.addEventListener('variant:change', function (evt) {
        // Only variants of this necklace count (quick view etc. fire the same event).
        var v = evt.detail && evt.detail.variant && this.findLookVariant(evt.detail.variant.id);
        if (!v) return;
        this.lookVariant = v;
        var p = this.lookPlating();
        if (p && this.platings.indexOf(p) >= 0) this.setPlating(p);
        // The theme resets the button text on variant change; render after it.
        setTimeout(this.render.bind(this), 0);
      }.bind(this));

      if (this.form) {
        // Capture phase: runs before the theme's own submit handler on the form.
        this.form.addEventListener('submit', this.onFormSubmit.bind(this), true);
      }
      // The necklace added with the theme's own button (no charms picked) switches the
      // row to adding charms straight away.
      document.addEventListener('ajaxProduct:added', function () { setTimeout(this.syncCart.bind(this), 0); }.bind(this));
      document.addEventListener('cart:updated', this.syncCart.bind(this));

      this.refreshCharms();
      this.render();
      this.syncCart();
    }

    // Tiles: one per button. A tile holds every product with the same data-tile
    // (Sanya Gold + Sanya Silver) and their variants with plating and the values
    // of the other options ("rest").
    buildTiles() {
      var byTile = {};
      this.data.charms.forEach(function (c) {
        var key = String(c.id);
        var padded = '-' + c.handle + '-';
        var stripped = padded.replace('-gold-', '-').replace('-silver-', '-');
        if (stripped !== padded && this.querySelector('[data-tile="' + CSS.escape(stripped) + '"]')) key = stripped;
        (byTile[key] = byTile[key] || []).push(c);
      }.bind(this));

      this.tiles = {};
      this.tileOfProduct = {};
      this.buttons = Array.prototype.slice.call(this.querySelectorAll('[data-tile]'));
      this.buttons.forEach(function (btn) {
        var key = btn.dataset.tile;
        var members = byTile[key] || [];
        if (!members.length) return;
        var tile = { key: key, btn: btn, products: members, variants: [], restOptions: null };
        members.forEach(function (c) {
          this.tileOfProduct[c.id] = key;
          var pIdx = platingIndex(c.options);
          var handlePlating = pIdx < 0 ? platingFromHandle(c.handle) : null;
          if (!tile.restOptions) tile.restOptions = c.options.filter(function (o, i) { return i !== pIdx; });
          if (pIdx >= 0) {
            c.options[pIdx].values.forEach(function (v) {
              var p = platingOf(v.name);
              if (!this.platingNames[p]) this.platingNames[p] = v.name;
            }.bind(this));
          }
          c.variants.forEach(function (v) {
            tile.variants.push({
              id: v.id,
              title: c.title,
              plating: pIdx >= 0 ? platingOf(v.options[pIdx]) : handlePlating,
              rest: v.options.filter(function (o, i) { return i !== pIdx; }),
              available: v.available,
              price: v.price,
              image: v.image,
              productImage: c.image,
              max: v.max
            });
          });
        }.bind(this));
        tile.letters = tile.restOptions.length === 1 && isLetters(tile.restOptions[0]);
        tile.choose = tile.restOptions.some(function (o) { return o.values.length > 1; });
        tile.platings = ORDER.filter(function (p) {
          return tile.variants.some(function (v) { return v.available && v.plating === p; });
        });
        tile.name = shortName(members[0].title);
        this.tiles[key] = tile;
      }.bind(this));

      // Platings in the row, in the order Gold, Silver.
      var tiles = this.tiles;
      this.platings = ORDER.filter(function (p) {
        return Object.keys(tiles).some(function (k) { return tiles[k].platings.indexOf(p) >= 0; });
      });
    }

    findLookVariant(id) {
      return this.data.look.variants.filter(function (v) { return v.id === Number(id); })[0];
    }

    lookPlating() {
      if (this.lookPlatingIdx < 0 || !this.lookVariant) return null;
      var name = this.lookVariant.options[this.lookPlatingIdx];
      var p = platingOf(name);
      if (p && !this.platingNames[p]) this.platingNames[p] = name;
      return p;
    }

    defaultPlating() {
      var p = this.lookPlating();
      if (p && this.platings.indexOf(p) >= 0) return p;
      if (this.platings.indexOf('gold') >= 0) return 'gold';
      return this.platings[0] || null;
    }

    // The shop's own word for the plating in the visitor's language (Guld, Silber ...).
    platingName(p) {
      return this.platingNames[p] || (p === 'gold' ? 'Gold' : 'Silver');
    }

    platingLower(p) {
      var name = this.platingName(p);
      // German nouns keep their capital (Nur in Silber).
      return /^de/i.test(document.documentElement.lang || '') ? name : name.toLowerCase();
    }

    buildToggle() {
      var wrap = this.querySelector('[data-charm-plating]');
      if (!wrap || this.platings.length < 2) return;
      wrap.setAttribute('aria-label', this.lookPlatingIdx >= 0 ? this.data.look.options[this.lookPlatingIdx] : 'Plating');
      this.toggleButtons = this.platings.map(function (p) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'charm-row__plating-btn';
        b.dataset.plating = p;
        var dot = document.createElement('span');
        dot.className = 'charm-row__plating-dot';
        dot.style.background = DOT[p];
        dot.setAttribute('aria-hidden', 'true');
        b.appendChild(dot);
        b.appendChild(document.createTextNode(this.platingName(p)));
        b.addEventListener('click', function () {
          this.setPlating(p);
          this.render();
        }.bind(this));
        wrap.appendChild(b);
        return b;
      }.bind(this));
      wrap.hidden = false;
    }

    setPlating(p) {
      if (!p || p === this.plating) return;
      this.plating = p;
      if (this.picker && !this.picker.hidden) this.closePicker();
      this.refreshCharms();
    }

    // The plating a tile uses: the toggle's if the tile has it, else the one it
    // has (shown as "Only in ..."); null = the tile has no plating.
    tilePlating(tile) {
      if (!tile.platings.length) return null;
      return tile.platings.indexOf(this.plating) >= 0 ? this.plating : tile.platings[0];
    }

    // Available variant of a tile in its plating for the values of the other
    // options (null/undefined = any value).
    variantFor(tile, rest) {
      var p = this.tilePlating(tile);
      return tile.variants.filter(function (v) {
        return v.available && (p === null || v.plating === p) &&
          v.rest.every(function (o, i) { return rest[i] === null || rest[i] === undefined || o === rest[i]; });
      })[0] || null;
    }

    variantById(tile, id) {
      return tile.variants.filter(function (v) { return v.id === id; })[0] || null;
    }

    // Values of the other options when there is nothing to choose, else null.
    fixedRest(tile) {
      if (tile.choose) return null;
      return tile.restOptions.map(function (o) { return o.values[0].name; });
    }

    tileImage(tile) {
      var p = this.tilePlating(tile);
      var vs = tile.variants.filter(function (v) { return p === null || v.plating === p; });
      if (!vs.length) return null;
      // One product per plating (Sanya): that product's image; else the first
      // variant image in the plating.
      if (tile.products.length > 1) return vs[0].productImage || vs[0].image;
      var withImage = vs.filter(function (v) { return v.available && v.image; })[0] || vs.filter(function (v) { return v.image; })[0];
      return withImage ? withImage.image : vs[0].productImage;
    }

    refreshCharms() {
      if (this.toggleButtons) {
        this.toggleButtons.forEach(function (b) {
          b.setAttribute('aria-pressed', b.dataset.plating === this.plating ? 'true' : 'false');
        }.bind(this));
      }
      Object.keys(this.tiles).forEach(function (key) {
        var tile = this.tiles[key];
        var btn = tile.btn;
        var p = this.tilePlating(tile);
        var other = p !== null && this.plating !== null && p !== this.plating;
        btn.classList.toggle('is-other', other);
        var only = btn.querySelector('[data-charm-only]');
        only.hidden = !other;
        if (other) only.textContent = this.t.only.replace('[plating]', this.platingLower(p));

        var img = btn.querySelector('img');
        var src = this.tileImage(tile);
        if (img && src && img.getAttribute('data-src-now') !== src) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = src;
          img.setAttribute('data-src-now', src);
        }

        var lines = this.inCart[key];
        var picks = this.picked[key];
        var variant;
        if (lines && lines.length) variant = this.variantById(tile, lines[0].variantId);
        else if (picks && picks.length) variant = this.variantFor(tile, picks[0].rest);
        else variant = this.variantFor(tile, this.fixedRest(tile) || []);
        if (variant) btn.querySelector('[data-charm-price]').textContent = money(variant.price);

        var dots = btn.querySelector('[data-charm-dots]');
        dots.textContent = '';
        tile.platings.forEach(function (tp) {
          var dot = document.createElement('span');
          dot.className = 'charm-row__dot' + (tp === p ? ' is-current' : '');
          dot.style.background = DOT[tp];
          dot.title = this.platingName(tp);
          dots.appendChild(dot);
        }.bind(this));

        var title = variant ? variant.title : tile.products[0].title;
        btn.dataset.labelAdd = this.t.add.replace('[title]', title);
        btn.dataset.labelRemove = this.t.remove.replace('[title]', title);
      }.bind(this));
    }

    onCharm(btn) {
      var tile = this.tiles[btn.dataset.tile];
      if (!tile) return;
      this.hideError();
      if (tile.letters) return this.openPicker(tile);
      if (this.inCart[tile.key]) return this.removeFromCart(tile);
      if (this.picked[tile.key]) {
        delete this.picked[tile.key];
        this.refreshCharms();
        return this.render();
      }
      var rest = this.fixedRest(tile);
      if (!rest) return this.openPicker(tile);
      if (!this.variantFor(tile, rest)) return;
      this.choose(tile, [{ rest: rest, qty: 1 }]);
    }

    // entries: [{ rest, qty }]; an empty list un-picks the tile.
    choose(tile, entries) {
      if (this.lookInCart) {
        if (entries.length) this.addToCart(tile, entries);
        return;
      }
      if (entries.length) this.picked[tile.key] = entries;
      else delete this.picked[tile.key];
      this.refreshCharms();
      this.render();
      if (entries.length) this.confirm(tile, entries);
    }

    // "Added: Stella – Gold" / "Added: Sanya A ×2, M – Gold".
    confirm(tile, entries) {
      var p = this.tilePlating(tile);
      var label = tile.name;
      if (tile.letters) {
        label += ' ' + entries.map(function (e) { return e.rest[0] + (e.qty > 1 ? ' ×' + e.qty : ''); }).join(', ');
      } else if (tile.choose) {
        label += ' ' + entries[0].rest.filter(function (r, i) { return tile.restOptions[i].values.length > 1; }).join(' ');
      }
      if (p) label += ' – ' + this.platingName(p);
      var el = this.querySelector('[data-charm-added]');
      el.textContent = this.t.added.replace('[title]', label);
      el.classList.add('is-visible');
      clearTimeout(this.addedTimer);
      this.addedTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 4000);
    }

    cartItems(tile, entries) {
      return entries.map(function (e) {
        var v = this.variantFor(tile, e.rest);
        return v ? { id: v.id, quantity: e.qty, properties: { _look: this.look } } : null;
      }.bind(this)).filter(Boolean);
    }

    addToCart(tile, entries) {
      var items = this.cartItems(tile, entries);
      if (!items.length) return;
      var btn = tile.btn;
      btn.classList.add('is-busy');
      postJSON(route('cart/add.js'), { items: items })
        .then(function () {
          this.confirm(tile, entries);
          return this.syncCart();
        }.bind(this))
        .then(function () { document.dispatchEvent(new CustomEvent('cart:build')); })
        .catch(this.showError.bind(this))
        .then(function () { btn.classList.remove('is-busy'); });
    }

    removeFromCart(tile) {
      var updates = {};
      (this.inCart[tile.key] || []).forEach(function (l) { updates[l.key] = 0; });
      var btn = tile.btn;
      btn.classList.add('is-busy');
      postJSON(route('cart/update.js'), { updates: updates })
        .then(function () { return this.syncCart(); }.bind(this))
        .then(function () { document.dispatchEvent(new CustomEvent('cart:build')); })
        .catch(this.showError.bind(this))
        .then(function () { btn.classList.remove('is-busy'); });
    }

    syncCart() {
      return fetch(route('cart.js'), { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var lookId = Number(this.dataset.productId);
          this.lookInCart = cart.items.some(function (item) { return item.product_id === lookId; });
          this.collectionInCart = cart.items.reduce(function (n, item) {
            return n + (this.tileOfProduct[item.product_id] ? item.quantity : 0);
          }.bind(this), 0);
          this.inCart = {};
          cart.items.forEach(function (item) {
            if (!item.properties || item.properties._look !== this.look) return;
            var key = this.tileOfProduct[item.product_id];
            if (!key) return;
            (this.inCart[key] = this.inCart[key] || []).push({
              key: item.key, variantId: item.variant_id, qty: item.quantity, price: item.final_line_price
            });
            if (!this.tiles[key].letters) delete this.picked[key];
          }.bind(this));
          this.refreshCharms();
          this.render();
        }.bind(this))
        .catch(function () {});
    }

    openPicker(tile) {
      this.pickerTile = tile;
      this.picker.hidden = false;
      var p = this.tilePlating(tile);
      this.querySelector('[data-picker-title]').textContent = tile.name + (p ? ' – ' + this.platingName(p) : '');
      this.querySelector('[data-picker-letters]').hidden = !tile.letters;
      var wrap = this.querySelector('[data-picker-options]');
      wrap.textContent = '';

      if (tile.letters) {
        // Picked but not yet in the cart: start from that selection (edit it).
        var start = this.lookInCart ? [] : (this.picked[tile.key] || []);
        this.pickerCounts = {};
        this.pickerOrder = [];
        start.forEach(function (e) {
          this.pickerCounts[e.rest[0]] = e.qty;
          this.pickerOrder.push(e.rest[0]);
        }.bind(this));
        this.pickerHadPick = start.length > 0;
      } else {
        this.pickerValues = tile.restOptions.map(function (o) { return o.values.length === 1 ? o.values[0].name : null; });
      }

      tile.restOptions.forEach(function (opt, i) {
        if (opt.values.length < 2) return;
        var label = document.createElement('p');
        label.className = 'charm-row__picker-label';
        label.id = 'CharmPick-' + tile.btn.dataset.charmId + '-' + i;
        label.textContent = opt.name;
        var group = document.createElement('div');
        group.className = 'charm-row__values';
        group.setAttribute('role', 'group');
        group.setAttribute('aria-labelledby', label.id);
        opt.values.forEach(function (value) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'charm-row__value';
          b.dataset.index = i;
          b.dataset.value = value.name;
          var text = document.createElement('span');
          text.textContent = value.name;
          b.appendChild(text);
          if (tile.letters) {
            var sold = document.createElement('span');
            sold.className = 'charm-row__value-sold';
            sold.textContent = this.t.soldOut;
            b.appendChild(sold);
          }
          b.addEventListener('click', function () {
            // Letters: every click adds one more, it never removes.
            if (tile.letters) this.addLetter(value.name);
            else this.pickerValues[i] = value.name;
            this.renderPicker();
          }.bind(this));
          group.appendChild(b);
        }.bind(this));
        wrap.appendChild(label);
        wrap.appendChild(group);
      }.bind(this));

      this.renderPicker();
      var first = wrap.querySelector('.charm-row__value:not(:disabled)');
      if (first) first.focus();
    }

    letterVariant(letter) {
      return this.variantFor(this.pickerTile, [letter]);
    }

    // How many more of a letter fit: the variant's stock (when Shopify tracks it
    // and does not oversell) minus the cart and the picker; no other limit.
    letterRoom(letter) {
      var v = this.letterVariant(letter);
      if (!v) return 0;
      if (v.max === null || v.max === undefined) return Infinity;
      var inCart = (this.inCart[this.pickerTile.key] || []).filter(function (l) { return l.variantId === v.id; })
        .reduce(function (n, l) { return n + l.qty; }, 0);
      return v.max - inCart - (this.pickerCounts[letter] || 0);
    }

    addLetter(letter) {
      if (this.letterRoom(letter) <= 0) return;
      if (!this.pickerCounts[letter]) this.pickerOrder.push(letter);
      this.pickerCounts[letter] = (this.pickerCounts[letter] || 0) + 1;
    }

    removeLetter(letter) {
      if (!this.pickerCounts[letter]) return;
      this.pickerCounts[letter] -= 1;
      if (!this.pickerCounts[letter]) {
        delete this.pickerCounts[letter];
        this.pickerOrder.splice(this.pickerOrder.indexOf(letter), 1);
      }
      this.renderPicker();
    }

    letterEntries() {
      return this.pickerOrder.map(function (l) { return { rest: [l], qty: this.pickerCounts[l] }; }.bind(this));
    }

    renderPicker() {
      var tile = this.pickerTile;
      var addBtn = this.querySelector('[data-picker-add]');
      if (tile.letters) return this.renderLetters(addBtn);
      // A value is offered only if some available variant in the tile's plating
      // has it together with the values already chosen for the other options.
      var values = this.pickerValues;
      var p = this.tilePlating(tile);
      this.picker.querySelectorAll('.charm-row__value').forEach(function (b) {
        var i = Number(b.dataset.index);
        var possible = tile.variants.some(function (v) {
          return v.available && (p === null || v.plating === p) && v.rest.every(function (o, j) {
            return j === i ? o === b.dataset.value : (values[j] === null || o === values[j]);
          });
        });
        b.disabled = !possible;
        b.setAttribute('aria-pressed', values[i] === b.dataset.value ? 'true' : 'false');
      });
      addBtn.disabled = values.some(function (v) { return v === null; }) || !this.variantFor(tile, values);
    }

    renderLetters(addBtn) {
      this.picker.querySelectorAll('.charm-row__value').forEach(function (b) {
        var available = !!this.letterVariant(b.dataset.value);
        b.disabled = !available || this.letterRoom(b.dataset.value) <= 0;
        b.classList.toggle('is-sold-out', !available);
        b.setAttribute('aria-pressed', this.pickerCounts[b.dataset.value] ? 'true' : 'false');
      }.bind(this));
      var chips = this.querySelector('[data-picker-chips]');
      chips.textContent = '';
      var count = 0;
      var total = 0;
      this.pickerOrder.forEach(function (letter) {
        var n = this.pickerCounts[letter];
        var v = this.letterVariant(letter);
        count += n;
        if (v) total += v.price * n;
        var li = document.createElement('li');
        li.className = 'charm-row__chip';
        var text = document.createElement('span');
        text.textContent = n > 1 ? letter + ' ×' + n : letter;
        var minus = document.createElement('button');
        minus.type = 'button';
        minus.className = 'charm-row__chip-remove';
        minus.setAttribute('aria-label', this.t.removeOne.replace('[title]', letter));
        minus.innerHTML = '<svg viewBox="0 0 20 20" width="12" height="12" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.8" fill="none"/></svg>';
        minus.addEventListener('click', this.removeLetter.bind(this, letter));
        li.appendChild(text);
        li.appendChild(minus);
        chips.appendChild(li);
      }.bind(this));
      this.querySelector('[data-picker-total]').textContent = count
        ? (count === 1 ? this.t.lettersOne : this.t.lettersMany).replace('[count]', count) + ' · ' + money(total)
        : '';
      // Empty after an earlier pick = take the letters out of the look.
      addBtn.disabled = !count && !this.pickerHadPick;
    }

    confirmPicker() {
      var tile = this.pickerTile;
      if (!tile) return;
      var entries = tile.letters ? this.letterEntries() : [{ rest: this.pickerValues.slice(), qty: 1 }];
      if (!tile.letters && !this.variantFor(tile, entries[0].rest)) return;
      this.closePicker();
      this.choose(tile, entries);
    }

    closePicker() {
      this.picker.hidden = true;
      if (this.pickerTile) this.pickerTile.btn.focus();
      this.pickerTile = null;
    }

    // Charms picked (not yet in the cart), counted per piece, and their price.
    pickedUnits() {
      var count = 0;
      var total = 0;
      Object.keys(this.picked).forEach(function (key) {
        var tile = this.tiles[key];
        this.picked[key].forEach(function (e) {
          var v = this.variantFor(tile, e.rest);
          if (!v) return;
          count += e.qty;
          total += v.price * e.qty;
        }.bind(this));
      }.bind(this));
      return { count: count, total: total };
    }

    render() {
      Object.keys(this.tiles).forEach(function (key) {
        var tile = this.tiles[key];
        var on = !!(this.picked[key] || this.inCart[key]);
        tile.btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        tile.btn.setAttribute('aria-label', on && !tile.letters ? tile.btn.dataset.labelRemove : tile.btn.dataset.labelAdd);
      }.bind(this));

      // "Your look": the necklace plus every charm picked or in the cart for it.
      var picked = this.pickedUnits();
      var n = picked.count;
      var total = picked.total;
      Object.keys(this.inCart).forEach(function (key) {
        this.inCart[key].forEach(function (l) { n += l.qty; total += l.price; });
      }.bind(this));
      var lookBox = this.querySelector('[data-charm-look]');
      lookBox.hidden = n === 0;
      if (n > 0) {
        total += this.lookVariant ? this.lookVariant.price : 0;
        this.querySelector('[data-look-summary]').textContent =
          this.lookName + ' + ' + (n === 1 ? this.t.one : this.t.many).replace('[count]', n);
        this.querySelector('[data-look-total]').textContent = money(total);
      }
      this.renderButton(picked.count);
      this.renderOffer(this.collectionInCart + picked.count, n > 0);
    }

    // Steps [count, percent] from the block settings, smallest count first.
    discountTiers() {
      var d = this.data.discount;
      if (!d || !d.show) return [];
      return d.tiers.filter(function (t) { return t[0] > 0 && t[1] > 0; })
        .sort(function (a, b) { return a[0] - b[0]; });
    }

    // Only texts: which step the charms reach is up to the discount function.
    renderOffer(count, lookShown) {
      var tiers = this.discountTiers();
      var hint = this.querySelector('[data-offer-hint]');
      var note = this.querySelector('[data-look-note]');
      if (!tiers.length) {
        if (note) note.hidden = true;
        return;
      }
      var next = tiers.filter(function (t) { return t[0] > count; })[0];
      var text;
      if (!next) {
        text = this.t.offerMax.replace('[percent]', tiers[tiers.length - 1][1]);
      } else if (count === 0 && next[0] === 1) {
        text = this.t.offerFirst.replace('[percent]', next[1]).replace('[product]', this.data.discount.product);
      } else {
        text = this.t.offerMore.replace('[count]', next[0] - count).replace('[percent]', next[1]);
      }
      if (hint) hint.textContent = text;
      if (note) note.hidden = !(lookShown && count >= tiers[0][0]);
    }

    // The product form's button reads "Add all N to cart" while charms are picked.
    renderButton(count) {
      if (!this.form) return;
      var span = this.form.querySelector('[data-add-to-cart-text]');
      var btn = this.form.querySelector('[name="add"]');
      if (!span || !btn) return;
      if (count > 0 && !btn.disabled) {
        span.textContent = this.t.addAll.replace('[count]', count + 1);
        this.buttonChanged = true;
      } else if (this.buttonChanged) {
        if (!btn.disabled) span.textContent = span.dataset.defaultText;
        this.buttonChanged = false;
      }
    }

    onFormSubmit(evt) {
      var keys = Object.keys(this.picked);
      if (!keys.length) return;
      evt.preventDefault();
      evt.stopImmediatePropagation();

      var form = this.form;
      var btn = form.querySelector('[name="add"]');
      var data = new FormData(form);
      var lookItem = { id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1), properties: {} };
      data.forEach(function (value, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m && typeof value === 'string') lookItem.properties[m[1]] = value;
      });
      if (data.get('selling_plan')) lookItem.selling_plan = Number(data.get('selling_plan'));
      var items = [lookItem];
      keys.forEach(function (key) {
        items = items.concat(this.cartItems(this.tiles[key], this.picked[key]));
      }.bind(this));

      if (btn) btn.classList.add('btn--loading');
      this.hideError();
      postJSON(route('cart/add.js'), { items: items })
        .then(function (res) {
          this.picked = {};
          form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: res.items ? res.items[0] : res, addToCartBtn: btn },
            bubbles: true
          }));
          return this.syncCart();
        }.bind(this))
        .catch(this.showError.bind(this))
        .then(function () {
          if (btn) btn.classList.remove('btn--loading');
        });
    }

    showError(err) {
      var el = this.querySelector('[data-charm-error]');
      if (err && err.description && typeof err.description === 'string') el.textContent = err.description;
      el.hidden = false;
    }

    hideError() {
      this.querySelector('[data-charm-error]').hidden = true;
    }
  }

  window.customElements.define('charm-row', CharmRow);
})();
